import type { ComponentType, SVGProps } from 'react';
import { Link } from 'react-router-dom';

import { Button } from '@/components/cargofl-ui';

/**
 * The one layout for a page that cannot be shown — 404, 403 — inside the shell, so the
 * sidebar stays and the way out is one click. The code is printed because it is what
 * somebody reads out when they report it.
 */
export function ErrorPage({
  code,
  art: Art,
  title,
  body,
}: {
  code: number;
  art: ComponentType<SVGProps<SVGSVGElement>>;
  title: string;
  body: string;
}) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <Art className="h-28 w-auto" />
      <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">
        {code}
      </p>
      <h1 className="text-2xl font-bold tracking-[-0.02em]">{title}</h1>
      <p className="max-w-[46ch] text-sm leading-relaxed text-muted-foreground">{body}</p>
      <Button asChild>
        <Link to="/">Back to overview</Link>
      </Button>
    </div>
  );
}
